import axios from 'axios';
import * as actionTypes from './actionTypes';

const authSuccess = (token, localId) => {
    return {
        type: actionTypes.AUTH_SUCCESS,
        payload: {
            token: token,
            userId: localId,
        }
    }
}

export const authLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('expirationTime');
    return {
        type: actionTypes.AUTH_lOGOUT
    }
}

export const authLoading = isLoading => {
    return {
        type: actionTypes.AUTH_lOADING,
        payload: isLoading,
    }
}

export const authFailed = errMsg => {
    return {
        type: actionTypes.AUTH_FAILED,
        payload: errMsg,
    }
}

export const auth = (email, password, mode) => dispatch => {
    dispatch(authLoading(true))
    const authData = {
        email: email,
        password: password,
        returnSecureToken: true,
    }
    const API_KEY = 'AIzaSyBGlcY-BgG7pSu7sJsHo55AUwUIIFl1A_s';
    let postUrl = null;

    if (mode === 'Login') {
        postUrl = `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${API_KEY}`;
    } else {
        postUrl = `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${API_KEY}`
    }

    axios.post(postUrl, authData)
        .then(response => {
            dispatch(authLoading(false))

            localStorage.setItem('token', response.data.idToken);
            localStorage.setItem('userId', response.data.localId);
            let expirationTime = new Date(new Date().getTime() + response.data.expiresIn * 1000);
            localStorage.setItem('expirationTime', expirationTime)
            dispatch(authSuccess(response.data.idToken, response.data.localId));
        })

        .catch(err => {
            dispatch(authLoading(false))
            // console.log(err.response.data.error.message);
            dispatch(authFailed(err.response.data.error.message));
        })// AUTH_FAILED
}

export const authCheck = () => dispatch => {
    const token = localStorage.getItem('token')
    if (!token) {
        //Logout , token is null
        dispatch(authLogout())
    } else {
        const expirationTime = new Date(localStorage.getItem('expirationTime'));
        if (expirationTime <= new Date()) {
            // Logout bacause expiration time is not valid
            dispatch(authLogout())
        }
        else {
            const userId = localStorage.getItem('userId');
            dispatch(authSuccess(token, userId));
        }
    }
}